import { css } from '@emotion/react';
import { t } from 'i18n';

import { theme } from '../../theme';
import { LegacyCartItem } from '../LegacyCartItem';

const styles = {
  bound: css`
    font-weight: ${theme.fontWeight.black};
  `,
};

type Props = {
  outboundOriginAirportCode?: string;
  outboundDestinationAirportCode?: string;

  inboundOriginAirportCode?: string;
  inboundDestinationAirportCode?: string;

  isTwoWay: boolean;
  className?: string;
};

export function BoundsCartItem({
  outboundOriginAirportCode,
  outboundDestinationAirportCode,
  inboundOriginAirportCode,
  inboundDestinationAirportCode,
  isTwoWay,
  className,
}: Props) {
  const outboundSelected = outboundOriginAirportCode && outboundDestinationAirportCode;
  const inboundSelected = inboundOriginAirportCode && inboundDestinationAirportCode;
  return (
    <LegacyCartItem
      className={className}
      title={isTwoWay ? t('common:roundTrip') : t('common:oneWay')}
      css={styles.bound}
    >
      <div>
        {outboundSelected && <div>{`${outboundOriginAirportCode} - ${outboundDestinationAirportCode}`}</div>}
        {inboundSelected && <div>{`${inboundOriginAirportCode} - ${inboundDestinationAirportCode}`}</div>}
      </div>
    </LegacyCartItem>
  );
}
